import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col gap-01 account-container" }
const _hoisted_2 = {
  class: "flex-row",
  style: {"gap":"16px"}
}
const _hoisted_3 = { class: "avatar-container" }
const _hoisted_4 = { class: "font-xlBold" }
const _hoisted_5 = { class: "flex-row align-center gap-10 w-full" }
const _hoisted_6 = { class: "font-mBold min-label-width" }
const _hoisted_7 = { class: "col gap-12px" }
const _hoisted_8 = { class: "flex-row" }
const _hoisted_9 = { class: "font-lBold" }
const _hoisted_10 = { class: "bg-modal w-maxC" }
const _hoisted_11 = { class: "row-top gap-10 mtop-04 flexwrap" }
const _hoisted_12 = {
  key: 0,
  class: "pleft-30px flex-row gap-02"
}
const _hoisted_13 = {
  key: 0,
  class: "pleft-30px flex-row gap-02"
}
const _hoisted_14 = { class: "flex-row" }
const _hoisted_15 = { class: "font-lBold" }
const _hoisted_16 = { class: "row-top gap-10 mtop-04 flexwrap" }
const _hoisted_17 = { class: "col pleft-30px gap-04" }
const _hoisted_18 = { class: "flex-row gap-02" }
const _hoisted_19 = { class: "col gap-12px" }
const _hoisted_20 = { class: "font-lBold" }
const _hoisted_21 = { class: "row-top gap-10 mtop-04 flexwrap" }
const _hoisted_22 = { class: "col pleft-30px gap-04" }
const _hoisted_23 = { class: "txt-grey-64 font-m" }
const _hoisted_24 = {
  key: 0,
  class: "col gap-10 mtop-04 w-full"
}
const _hoisted_25 = { class: "font-lBold" }
const _hoisted_26 = { class: "flex-row align-center gap-10 w-full" }
const _hoisted_27 = { class: "font-mBold min-label-width" }
const _hoisted_28 = { class: "flex-row align-center gap-10 w-full" }
const _hoisted_29 = { class: "font-mBold min-label-width" }
const _hoisted_30 = {
  key: 1,
  class: "gap-10 mtop-04 w-full flex-col"
}
const _hoisted_31 = { class: "font-lBold" }
const _hoisted_32 = { class: "flex-row align-center gap-10 w-full" }
const _hoisted_33 = { class: "font-mBold min-label-width" }
const _hoisted_34 = { class: "font-mBold min-label-width" }
const _hoisted_35 = {
  key: 0,
  class: "mtop-08"
}
const _hoisted_36 = { class: "font-mBold min-label-width mbottom-10 block" }
const _hoisted_37 = { class: "font-mBold min-label-width mtop-08" }
const _hoisted_38 = { class: "flex-row align-center gap-10 w-full" }
const _hoisted_39 = { class: "font-mBold min-label-width mtop-08" }
const _hoisted_40 = { class: "flex-row align-center gap-10 w-full" }
const _hoisted_41 = { class: "font-mBold min-label-width mtop-08" }
const _hoisted_42 = { class: "flex-row align-center gap-10 w-full" }
const _hoisted_43 = { class: "font-mBold min-label-width mtop-08" }
const _hoisted_44 = { class: "flex-row align-center gap-10 w-full" }
const _hoisted_45 = { class: "font-mBold min-label-width mtop-08" }
const _hoisted_46 = { class: "flex-row align-center gap-10 w-full" }
const _hoisted_47 = { class: "font-mBold min-label-width mtop-08" }
const _hoisted_48 = { class: "flex-row align-center gap-10 w-full" }
const _hoisted_49 = { class: "font-mBold min-label-width mtop-08" }
const _hoisted_50 = { class: "flex-row align-center gap-10 w-full" }

import { useI18n } from 'vue-i18n';
import { useAppUserStore } from '@/stores/appUser';
import { computed, onMounted, ref, watch } from "vue";
import StringService from '@/services/StringService';
import PhoneInput from '@/views/patientMain/dashbAdmin/person/phoneInput.vue';
import EmailInput from '@/views/patientMain/dashbAdmin/person/emailInput.vue';
import EsDataCard from '@/components/esDataCard.vue';
import gen from '@/functions/general';
import { getFlagEmojiForPrefix } from '@/functions/geo';
import AddressInput from '@/views/patientMain/dashbAdmin/person/addressInput.vue';
import { AddressPersonRequest, ApiError, DoctorInformation, PersonApi, InstituteApi, UpdateDoctorTitleRequest, UpdateEmailPwrRequest, UpdatePersonWithRoleAddressRequest, UpdatePersonWithRoleEmailRequest, UpdatePersonWithRolePhoneRequest, UpdatePhonePwrRequest, HealthPro } from '@/apiGenerate/medserver';
import { medServerApiConfig } from "@/config/medserver-api.config";
import { useToast } from 'primevue';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import Checkbox from 'primevue/checkbox';
import EsEditor from '@/components/esEditor.vue'
import { PersonWithRoleStatus } from '@/models/share.model';
import { PHONE_PREFIX_LIST, getFlagEmojiForCountry } from "@/functions/geo";
import UpdateAccountInstitutePreferenceForm from "@/components/form/account/updateAccountInstitutePreferenceForm.vue";
import officeapi from '@/api/officeapi';
import esHealthProSlugSettings from "@/views/officeMain/settings/esHealthProSlugSettings.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'esAccountSettings',
  setup(__props) {


const { t } = useI18n();
const appUserStore = useAppUserStore();
const dropd = ref("");
const toast = useToast();

const personApi = new PersonApi(medServerApiConfig);

const doctorInformationPortailPatient = ref<DoctorInformation>({
  fees: "",
  meansOfPayment: "",
  diploma: "",
  presentation: "",
  generalMessage: ""
});
const instituteSlugs = ref<string[]>([]);
const slug = ref<string | null>(null);

const currentPersonWithRole = appUserStore.currentHealthGroupMembership?.pwr;

if (currentPersonWithRole) {
  const sortedPhones = sortByPreferredAndDate(currentPersonWithRole.phones);
  currentPersonWithRole.phones.splice(0, currentPersonWithRole.phones.length, ...sortedPhones);

  const sortedEmails = sortByPreferredAndDate(currentPersonWithRole.emails);
  currentPersonWithRole.emails.splice(0, currentPersonWithRole.emails.length, ...sortedEmails);

  const sortedAddresses = sortByPreferredAndDate(currentPersonWithRole.addresses);
  currentPersonWithRole.addresses.splice(0, currentPersonWithRole.addresses.length, ...sortedAddresses);

  if (!currentPersonWithRole.infoPortailPatient || typeof currentPersonWithRole.infoPortailPatient !== 'object') {
    currentPersonWithRole.infoPortailPatient = {
      fees: [""],
      paymentSolution: [""],
      presentation: "",
      diploma: [""]
    };
  }
}
const pwrInstitutes = appUserStore.currentAppUserData.healthGroupMemberships.map((healthGroupMemberships) => {
  return {institute: healthGroupMemberships.instituteWithRole, 
          role: currentPersonWithRole.personRoleType};
});

const userNameTerm = computed(() => {
  return currentPersonWithRole ? StringService.getInitial(currentPersonWithRole.lastName ?? "", currentPersonWithRole.firstName ?? "") : "";
});

const pwrPhones = computed(() => currentPersonWithRole?.phones ?? []);
const pwrEmails = computed(() => currentPersonWithRole?.emails ?? []);
const pwrAdresses = computed(() => currentPersonWithRole?.addresses ?? []);
 
const roleLabels: Record<string, string> = {
  Admin: t('settings.params.account.institutes.roles.admin'),
  CustomLearningSpeaker: t('settings.params.account.institutes.roles.customLearningSpeaker'),
  CustomPatient: t('settings.params.account.institutes.roles.customPatient'),
  HealthPro: t('settings.params.account.institutes.roles.healthPro'),
  HealthProAssistant: t('settings.params.account.institutes.roles.healthProAssistant')
};

function sendEmail(email: string) {
  window.location.href = gen.getEmailUrl(email);
}

function callNumber(phoneNumber: string, phonePrefix: string) {
  window.location.href = gen.getTelUrl(phoneNumber, phonePrefix);
}

function contact (rawNumber: string) {
  if (rawNumber === '') return rawNumber
  return rawNumber.match(/.{1,3}/g).join(' ')
}

/**
 * update the person phones list from a new list
 *
 * @param newPhones the new list to use
 */
function updatePwrPhones(newPhones) {
  if (!currentPersonWithRole) return;

  const sortedPhones = sortByPreferredAndDate(newPhones);

  currentPersonWithRole.phones.splice(0, currentPersonWithRole.phones.length, ...sortedPhones);
}

/**
 * update the person emails list from a new list
 *
 * @param newEmails the new list to use
 */
function updatePwrEmails(newEmails) {
  if (!currentPersonWithRole) return;

  const sortedEmails = sortByPreferredAndDate(newEmails);

  currentPersonWithRole.emails.splice(0, currentPersonWithRole.emails.length, ...sortedEmails);
}

/**
 * update the person addresses list from a new list
 *
 * @param newAddresses the new list to use
 */
function updatePwrAddresses(newAddresses) {
  if (!currentPersonWithRole) return;

  const sortedAddresses = sortByPreferredAndDate(newAddresses);

  currentPersonWithRole.addresses.splice(0, currentPersonWithRole.addresses.length, ...sortedAddresses);
}

/**
 * Updates the doctor's title lines (line 1 and line 2) for the current user's PWR (Person With Role).
 * 
 * This function retrieves the current PWR from the store and sends an update request
 * to the server using the `PersonApi` service. If the update is successful, a success
 * toast notification is shown. If an error occurs, an error toast is displayed.
 *
 * @async
 * @function updatePwrTitle
 * @returns {Promise<void>} Nothing is returned. The result is handled via toast notifications.
 */
const updatePwrTitle = async () => {
  if (!currentPersonWithRole) return;
  const updateTitle: UpdateDoctorTitleRequest = {
    titleLine1: currentPersonWithRole.titleLine1,
    titleLine2: currentPersonWithRole.titleLine2,
    title: currentPersonWithRole.title
  };

  await personApi.updateDoctorTitle({
    personId: currentPersonWithRole.personWithRoleId,
    updateDoctorTitleRequest: updateTitle,
  })
  .then(() => {
    toastSuccess(toast, {
      summary: t('common.toast.success.update'),
      detail: t('settings.params.account.toast.update.information'),
    });
    appUserStore.setCurrentHealthGroupMembership(currentPersonWithRole)
  })
  .catch((error: ApiError) => {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: t(`error.${error.status}`)
    });
  });
};

/**
 * Updates the doctor's information in the patient portal.
 * Sends updated fields (fees, payment methods, diploma, presentation, teleconsultation, and new patient availability) to the API.
 */
const updatePwrInformationPortailPatient = async () => {
  if (!currentPersonWithRole) return;

  const updateDoctorRequest : DoctorInformation = {
    fees: doctorInformationPortailPatient.value.fees,
    meansOfPayment: doctorInformationPortailPatient.value.meansOfPayment,
    diploma: doctorInformationPortailPatient.value.diploma,
    presentation: doctorInformationPortailPatient.value.presentation,
    isTeleconsultationAvailable: doctorInformationPortailPatient.value.isTeleconsultationAvailable,
    openToNewPatients: doctorInformationPortailPatient.value.openToNewPatients,
    complementaryInformation: doctorInformationPortailPatient.value.complementaryInformation,
    weekSchedule: doctorInformationPortailPatient.value.weekSchedule,
    generalMessage: doctorInformationPortailPatient.value.generalMessage
  }

  await personApi.updateDoctorInformation({
    doctorId: currentPersonWithRole.personWithRoleId,
    doctorInformation: updateDoctorRequest
  })
  .then(() => {
    toastSuccess(toast, {
      summary: t('common.toast.success.update'),
      detail: t('settings.params.account.toast.update.information'),
    });
  })
  .catch((error: ApiError) => {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  });
}

const updateMeanOfPayement = async (newJsonValue: string) => {
  doctorInformationPortailPatient.value.meansOfPayment = newJsonValue;
  await updatePwrInformationPortailPatient();
}

const updateFee = async (newJsonValue: string) => {
  doctorInformationPortailPatient.value.fees = newJsonValue;
  await updatePwrInformationPortailPatient();
}

const updateDiploma = async (newJsonValue: string) => {
  doctorInformationPortailPatient.value.diploma = newJsonValue;
  await updatePwrInformationPortailPatient();
}

const updatePresentation= async (newJsonValue: string) => {
  doctorInformationPortailPatient.value.presentation = newJsonValue;
  await updatePwrInformationPortailPatient();
}

const updateWeekSchedule= async (newJsonValue: string) => {
  doctorInformationPortailPatient.value.weekSchedule = newJsonValue;
  await updatePwrInformationPortailPatient();
}

const updateComplementaryInformation= async (newJsonValue: string) => {
  doctorInformationPortailPatient.value.complementaryInformation = newJsonValue;
  await updatePwrInformationPortailPatient();
}

const updateGeneralMessage = async (newValue: string) => {
  doctorInformationPortailPatient.value.generalMessage = newValue;
  await updatePwrInformationPortailPatient();
}

/**
 * sort a list of item using isPreferred and created attribute. First sort using isPreferred, then by date of creation
 *
 * @param items the list to sort
 * @return the sorted list
 */
function sortByPreferredAndDate(items: { isPreferred: boolean, created: string }[]) {
  return [...items].sort((a, b) => {
    if (a.isPreferred && !b.isPreferred) return -1;
    if (!a.isPreferred && b.isPreferred) return 1;

    const dateA = new Date(a.created);
    const dateB = new Date(b.created);
    return dateA.getTime() - dateB.getTime();
  });
}

/**
 * Fetches the doctor's information from the API
 * and updates the local reactive state.
 */
const getDoctorInformation = async () => {
  await personApi.getDoctor({
    doctorId: currentPersonWithRole.personWithRoleId,
    instituteUuid: appUserStore.currentHealthGroupMembership?.instituteWithRole.instituteWithRoleId,
    fetchFullInformation: true
  })
  .then((response: HealthPro) => {
    doctorInformationPortailPatient.value = { ...response };
  })
  .catch((error: ApiError) => {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  });
}

const updateAddress = async (addressPersonRequest: AddressPersonRequest, addressId: string) => {
  if (addressPersonRequest && currentPersonWithRole && addressId) {
    const updatePersonWithRoleAddressRequest: UpdatePersonWithRoleAddressRequest = {
      personId: currentPersonWithRole.personWithRoleId,
      personAddressId: addressId,
      addressPersonRequest: addressPersonRequest
    }
    personApi.updatePersonWithRoleAddress(updatePersonWithRoleAddressRequest).then(async () => {
      await appUserStore.updateCurrentHealthGroupMembership();
      dropd.value = '';
      toastSuccess(toast, {
        summary: t('common.toast.success.update'),
        detail: t('settings.params.account.toast.update.address')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });
    });
  }
}

const getDoctorSlug = async () => {
  if(currentPersonWithRole) {
    try {
      const doctorSlug = await personApi.getDoctorSlug({ doctorId: currentPersonWithRole?.personWithRoleId });
      slug.value = doctorSlug.value ?? null;
    } catch (error: ApiError) {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });
    }
  }
}

const updateEmail = async (updateEmailPwrRequest: UpdateEmailPwrRequest, emailId: string) => {
  if (updateEmailPwrRequest && currentPersonWithRole && emailId) {
    const updatePersonWithRoleEmailRequest: UpdatePersonWithRoleEmailRequest = {
      emailId: emailId,
      personId: currentPersonWithRole.personWithRoleId,
      updateEmailPwrRequest: updateEmailPwrRequest
    };
    
    personApi.updatePersonWithRoleEmail(updatePersonWithRoleEmailRequest).then(async () => {
      await appUserStore.updateCurrentHealthGroupMembership();
      dropd.value = '';
      toastSuccess(toast, {
        summary: t('common.toast.success.update'),
        detail: t('settings.params.account.toast.update.email')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });
    });
  }
}

const updatePhone = async (updatePhonePwrRequest: UpdatePhonePwrRequest, phoneId: string) => {
  if (updatePhonePwrRequest && currentPersonWithRole && phoneId) {
    const updatePersonWithRolePhone: UpdatePersonWithRolePhoneRequest = {
      phoneId: phoneId,
      personId: currentPersonWithRole.personWithRoleId,
      updatePhonePwrRequest: updatePhonePwrRequest
    }

    personApi.updatePersonWithRolePhone(updatePersonWithRolePhone).then(async () => {
      await appUserStore.updateCurrentHealthGroupMembership();
      dropd.value = '';
      toastSuccess(toast, {
        summary: t('common.toast.success.update'),
        detail: t('settings.params.account.toast.update.phone')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });
    });
  }
}

const deleteEmail = async (emailId: string) => {
  if (emailId && currentPersonWithRole) {
    personApi.deletePersonWithRoleEmail({personId: currentPersonWithRole.personWithRoleId, emailId: emailId, isPatient: false}).then(async () => {
      await appUserStore.updateCurrentHealthGroupMembership();
      toastSuccess(toast, {
        summary: t('common.toast.success.delete'),
        detail: t('settings.params.account.toast.delete.email')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });
    });
  }
}

const deletePhone = async (phoneId: string) => {
  if (phoneId  && currentPersonWithRole) {
    personApi.deletePersonWithRolePhone({personId: currentPersonWithRole.personWithRoleId, phoneId: phoneId, isPatient: false}).then(async () => {
      await appUserStore.updateCurrentHealthGroupMembership();
      toastSuccess(toast, {
        summary: t('common.toast.success.delete'),
        detail: t('settings.params.account.toast.delete.phone')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });
    });
  }
}

const deleteAddress = async (addressId: string) => {
  if (addressId && currentPersonWithRole) {
    personApi.deletePersonWithRoleAddress({personId: currentPersonWithRole.personWithRoleId, personAddressId: addressId, isPatient: false}).then(async () => {
      await appUserStore.updateCurrentHealthGroupMembership();

      toastSuccess(toast, {
        summary: t('common.toast.success.delete'),
        detail: t('settings.params.account.toast.delete.address')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });
    });
  }
}

const createPhone = async (value: {phonePrefix: string, phoneNumber: number, phoneIsMobile: boolean, phoneNote: string}) => {
  if (currentPersonWithRole && value) {
    try {
      await officeapi.addPhoneToPwr(currentPersonWithRole.personWithRoleId, value.phonePrefix, value.phoneNumber, value.phoneIsMobile, value.phoneNote);
      await appUserStore.updateCurrentHealthGroupMembership();
      toastSuccess(toast, {
        summary: t('common.toast.success.add'),
        detail: t('settings.params.account.toast.add.phone')
      })
    } catch (error: ApiError) {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      })
    }
  }
}

const createEmail = async (value: {email: string, note: string}) => {
  if (currentPersonWithRole && value) {
    try {
      await officeapi.addEmailToPwr(currentPersonWithRole.personWithRoleId, value.email, value.note);
      await appUserStore.updateCurrentHealthGroupMembership();

      toastSuccess(toast, {
        summary: t('common.toast.success.add'),
        detail: t('settings.params.account.toast.add.email')
      });
    } catch (error: ApiError) {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      })
    }
  }
}

const createAddress = async (personAddress: AddressPersonRequest) => {
  if (currentPersonWithRole && personAddress) {
    personApi.createPersonWithRoleAddress({personId: currentPersonWithRole.personWithRoleId, isPatient: false, addressPersonRequest: personAddress})
      .then(async () => {
        await appUserStore.updateCurrentHealthGroupMembership();

        toastSuccess(toast, {
          summary: t('common.toast.success.add'),
          detail: t('settings.params.account.toast.add.address')
        });
      }).catch((error: ApiError) => {
        toastError(toast, {
          summary: t('common.toast.error'),
          detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
        });
      });
  }
}
const onDoctorSlugUpdate = (value: string) => {
  slug.value = value;
}

const getInstitutesSlugs = async () => {
  const currentInstituteId = appUserStore.currentHealthGroupMembership?.instituteWithRole.instituteWithRoleId;
  const instituteIds: string[] = pwrInstitutes.map((pwrInstitute: any) => pwrInstitute.institute.instituteWithRoleId);
  const instituteApi = new InstituteApi(medServerApiConfig);
  try {
    const slugs = await Promise.all(instituteIds.map(async (id) => {
      const { value } = await instituteApi.getInstituteSlug({ instituteId: id });
      return { id, slug: value ?? null };
    }));
    instituteSlugs.value = slugs.filter(({ slug }) => Boolean(slug)).sort((a, b) => {
      if (a.id === currentInstituteId) {
        return 1;
      } else if (b.id === currentInstituteId) {
        return -1;
      }

      return a.slug.localeCompare(b.slug);
    })
    .map(({ slug }) => slug);
  } catch (error: ApiError) {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  }
}

onMounted(() => {
  getDoctorInformation();
  getDoctorSlug();
  getInstitutesSlugs();
});

watch(
    () => appUserStore.currentHealthGroupMembership?.pwr.phones,
    (newVal) => {
      updatePwrPhones([...newVal]);
    },
    { deep: true }
);

watch(
    () => appUserStore.currentHealthGroupMembership?.pwr.emails,
    (newVal) => {
      updatePwrEmails([...newVal]);
    },
    { deep: true }
);

watch(
  () => appUserStore.currentHealthGroupMembership?.pwr.addresses,
  (newVal) => {
    updatePwrAddresses([...newVal]);
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_list_group = _resolveComponent("list-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(userNameTerm.value), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(currentPersonWithRole).firstName) + " " + _toDisplayString(((_unref(currentPersonWithRole).lastName) as string).toUpperCase()), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(t)('settings.params.account.details.title')), 1),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(currentPersonWithRole).title) = $event)),
        class: "input-style pad-m",
        type: "text",
        onBlur: updatePwrTitle
      }, null, 544), [
        [_vModelText, _unref(currentPersonWithRole).title]
      ])
    ]),
    _cache[37] || (_cache[37] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('settings.params.account.details.contact')), 1),
        _createVNode(_component_dropdownBox, {
          modelValue: dropd.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dropd).value = $event)),
          openOn: "addNewFix"
        }, {
          dropd: _withCtx(() => [
            _createVNode(PhoneInput, {
              pwr: _unref(currentPersonWithRole),
              newIsMobile: false,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (dropd.value = '')),
              ownerType: "healthGroup",
              onCreatePersonPhone: _cache[2] || (_cache[2] = ($event: any) => (createPhone($event)))
            }, null, 8, ["pwr"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_dropdownBox, {
          modelValue: dropd.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dropd).value = $event)),
          openOn: "addNewMobile"
        }, {
          dropd: _withCtx(() => [
            _createVNode(PhoneInput, {
              pwr: _unref(currentPersonWithRole),
              newIsMobile: true,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (dropd.value = '')),
              ownerType: "healthGroup",
              onCreatePersonPhone: _cache[5] || (_cache[5] = ($event: any) => (createPhone($event)))
            }, null, 8, ["pwr"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_dropdownBox, {
          modelValue: dropd.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dropd).value = $event)),
          openOn: "addNewEmail"
        }, {
          dropd: _withCtx(() => [
            _createVNode(EmailInput, {
              pwr: _unref(currentPersonWithRole),
              onClose: _cache[7] || (_cache[7] = ($event: any) => (dropd.value = '')),
              ownerType: "healthGroup",
              onCreatePersonEmail: _cache[8] || (_cache[8] = ($event: any) => (createEmail($event)))
            }, null, 8, ["pwr"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_dropdownBox, {
          modelValue: dropd.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((dropd).value = $event)),
          openOn: "addNewContact"
        }, {
          dropd: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_list_group, {
                styles: "pad-s",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (dropd.value = 'addNewFix'))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "phone",
                    styles: "main-m"
                  }),
                  _createVNode(_component_text_item, {
                    txt: "Fixe",
                    class: "mleft-06"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_list_group, {
                styles: "pad-s",
                class: "mtop-04",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (dropd.value = 'addNewMobile'))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "mobile",
                    styles: "main-m"
                  }),
                  _createVNode(_component_text_item, {
                    txt: "Mobile",
                    class: "mleft-06"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_list_group, {
                styles: "pad-s",
                class: "mtop-04",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (dropd.value = 'addNewEmail'))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "mail",
                    styles: "main-m"
                  }),
                  _createVNode(_component_text_item, {
                    txt: "Email",
                    class: "mleft-06"
                  })
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_button_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "plus",
                  styles: "main-m"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pwrPhones.value, (phone, indexPhone) => {
          return (_openBlock(), _createBlock(_component_dropdownBox, {
            key: indexPhone,
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((dropd).value = $event)),
            openOn: 'input-phone-' + indexPhone,
            class: "cursor-action"
          }, {
            dropd: _withCtx(() => [
              _createVNode(PhoneInput, {
                "is-update": true,
                ref_for: true,
                ref: 'input-phone-' + indexPhone,
                phone: phone,
                ownerType: "healthGroup",
                pwr: _unref(currentPersonWithRole),
                onUpdatePersonPhone: ($event: any) => (updatePhone($event, phone.personPhoneId)),
                onDeletePersonPhone: ($event: any) => (deletePhone(phone.personPhoneId)),
                onClose: _cache[14] || (_cache[14] = ($event: any) => (dropd.value = ''))
              }, null, 8, ["phone", "pwr", "onUpdatePersonPhone", "onDeletePersonPhone"])
            ]),
            default: _withCtx(() => [
              _createVNode(EsDataCard, {
                title: phone.isMobile ? _unref(t)('patient.admin.mobile') : _unref(t)('patient.admin.phone'),
                icon: phone.isMobile ? 'iphone-gen2' : 'phone_fill',
                folderIcon: 'shareIcons',
                ref_for: true,
                ref: 'phone-' + indexPhone,
                backgroundClass: "bg-blue-04",
                onIconClick: ($event: any) => (callNumber(phone.phoneNumber, phone.phonePrefix))
              }, {
                default: _withCtx(() => [
                  (/^\d+$/.test(phone.phonePrefix) && _unref(PHONE_PREFIX_LIST).find(item => item.prefix === phone.phonePrefix))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_text_item, {
                          txt: _unref(getFlagEmojiForPrefix)(phone.phonePrefix) + ' +' + _unref(PHONE_PREFIX_LIST).find(item => item.prefix === phone.phonePrefix).prefix,
                          class: "txt-grey-64"
                        }, null, 8, ["txt"]),
                        _createVNode(_component_text_item, {
                          txt: contact(phone.phoneNumber),
                          class: "txt-grey-64"
                        }, null, 8, ["txt"])
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_unref(PHONE_PREFIX_LIST).find(item => item.isoCode === phone.phonePrefix))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(_component_text_item, {
                                txt: _unref(getFlagEmojiForCountry)(phone.phonePrefix) + ' +' + _unref(PHONE_PREFIX_LIST).find(item => item.isoCode === phone.phonePrefix).prefix,
                                class: "txt-grey-64"
                              }, null, 8, ["txt"]),
                              _createVNode(_component_text_item, {
                                txt: contact(phone.phoneNumber),
                                class: "txt-grey-64"
                              }, null, 8, ["txt"])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                ]),
                _: 2
              }, 1032, ["title", "icon", "onIconClick"])
            ]),
            _: 2
          }, 1032, ["modelValue", "openOn"]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pwrEmails.value, (mail, indexMail) => {
          return (_openBlock(), _createBlock(_component_dropdownBox, {
            key: indexMail,
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((dropd).value = $event)),
            openOn: 'input-mail-' + indexMail,
            class: "cursor-action"
          }, {
            dropd: _withCtx(() => [
              _createVNode(EmailInput, {
                "is-update": true,
                ref_for: true,
                ref: 'input-mail-' + indexMail,
                email: mail,
                ownerType: "healthGroup",
                pwr: _unref(currentPersonWithRole),
                onUpdatePersonEmail: ($event: any) => (updateEmail($event, mail.personEmailId)),
                onDeletePersonEmail: ($event: any) => (deleteEmail(mail.personEmailId)),
                onClose: _cache[16] || (_cache[16] = ($event: any) => (dropd.value = ''))
              }, null, 8, ["email", "pwr", "onUpdatePersonEmail", "onDeletePersonEmail"])
            ]),
            default: _withCtx(() => [
              _createVNode(EsDataCard, {
                title: _unref(t)('patient.admin.email'),
                icon: 'envelope_fill',
                folderIcon: 'shareIcons',
                ref_for: true,
                ref: 'mail-' + indexMail,
                backgroundClass: "bg-blue-04",
                onIconClick: ($event: any) => (sendEmail(mail.email))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: mail.email,
                    class: "pleft-30px txt-grey-64"
                  }, null, 8, ["txt"])
                ]),
                _: 2
              }, 1032, ["title", "onIconClick"])
            ]),
            _: 2
          }, 1032, ["modelValue", "openOn"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('settings.params.account.details.address')), 1),
        _createVNode(_component_dropdownBox, {
          modelValue: dropd.value,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((dropd).value = $event)),
          openOn: "addNewAddress"
        }, {
          dropd: _withCtx(() => [
            _createVNode(AddressInput, {
              pwr: _unref(currentPersonWithRole),
              onClose: _cache[18] || (_cache[18] = ($event: any) => (dropd.value = '')),
              "owner-type": 'healthGroup',
              onCreatePersonAddress: _cache[19] || (_cache[19] = ($event: any) => (createAddress($event)))
            }, null, 8, ["pwr"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_button_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "plus",
                  styles: "main-m"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pwrAdresses.value, (address, indexAddress) => {
          return (_openBlock(), _createBlock(_component_dropdownBox, {
            key: indexAddress,
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((dropd).value = $event)),
            openOn: 'input-address-' + indexAddress,
            class: "cursor-action"
          }, {
            dropd: _withCtx(() => [
              _createVNode(AddressInput, {
                "is-update": true,
                pwr: _unref(currentPersonWithRole),
                ref_for: true,
                ref: 'input-address-' + indexAddress,
                address: address,
                ownerType: "healthGroup",
                onClose: _cache[21] || (_cache[21] = ($event: any) => (dropd.value = '')),
                onUpdatePersonAddress: ($event: any) => (updateAddress($event, address.personAddressId)),
                onDeletePersonAddress: ($event: any) => (deleteAddress(address.personAddressId))
              }, null, 8, ["pwr", "address", "onUpdatePersonAddress", "onDeletePersonAddress"])
            ]),
            default: _withCtx(() => [
              _createVNode(EsDataCard, {
                title: _unref(t)('patient.admin.address'),
                icon: "house_fill",
                folderIcon: "shareIcons",
                ref_for: true,
                ref: "'address-' + indexAddress",
                backgroundClass: "bg-blue-04"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_text_item, {
                      txt: address.street,
                      class: "txt-grey-64"
                    }, null, 8, ["txt"]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_text_item, {
                        txt: address.postalCodePrefix + address.postalCode,
                        class: "txt-grey-64"
                      }, null, 8, ["txt"]),
                      _createVNode(_component_text_item, {
                        txt: address.locality,
                        class: "txt-grey-64"
                      }, null, 8, ["txt"])
                    ]),
                    _createVNode(_component_text_item, {
                      txt: address.country,
                      class: "txt-grey-64"
                    }, null, 8, ["txt"])
                  ])
                ]),
                _: 2
              }, 1032, ["title"])
            ]),
            _: 2
          }, 1032, ["modelValue", "openOn"]))
        }), 128))
      ])
    ]),
    _cache[38] || (_cache[38] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)('settings.params.account.institutes.title')), 1),
      _createElementVNode("div", _hoisted_21, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pwrInstitutes), (pwrInstitute, indexInstitutes) => {
          return (_openBlock(), _createBlock(_component_dropdownBox, {
            key: indexInstitutes,
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((dropd).value = $event)),
            openOn: 'input-institut-' + indexInstitutes,
            class: "cursor-action"
          }, {
            dropd: _withCtx(() => [
              _createVNode(UpdateAccountInstitutePreferenceForm, {
                header: _unref(t)('settings.label.account.institute.preference.header', {'instituteName': pwrInstitute.institute.instituteName}),
                "institute-id": pwrInstitute.institute.instituteWithRoleId,
                onModalClose: _cache[23] || (_cache[23] = ($event: any) => (dropd.value = ''))
              }, null, 8, ["header", "institute-id"])
            ]),
            default: _withCtx(() => [
              _createVNode(EsDataCard, {
                title: pwrInstitute.institute.instituteShortName,
                icon: 'building-2_fill',
                folderIcon: 'shareIcons',
                ref_for: true,
                ref: 'institute-' + indexInstitutes,
                backgroundClass: "bg-blue-04"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(roleLabels[pwrInstitute.role]), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["title"])
            ]),
            _: 2
          }, 1032, ["modelValue", "openOn"]))
        }), 128))
      ])
    ]),
    _cache[39] || (_cache[39] = _createElementVNode("div", { class: "separator" }, null, -1)),
    (_unref(currentPersonWithRole)?.personRoleType == _unref(PersonWithRoleStatus).HealthPro)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('settings.params.account.prescription.title')), 1),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(t)('settings.params.account.prescription.labelTitleLine1')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(currentPersonWithRole).titleLine1) = $event)),
              class: "input-style flex-1 pad-m",
              type: "text",
              onBlur: updatePwrTitle
            }, null, 544), [
              [_vModelText, _unref(currentPersonWithRole).titleLine1]
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(t)('settings.params.account.prescription.labelTitleLine2')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(currentPersonWithRole).titleLine2) = $event)),
              class: "input-style flex-1 pad-m",
              type: "text",
              onBlur: updatePwrTitle
            }, null, 544), [
              [_vModelText, _unref(currentPersonWithRole).titleLine2]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(currentPersonWithRole)?.personRoleType == _unref(PersonWithRoleStatus).HealthPro)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "separator" }, null, -1)),
          _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(t)('settings.params.account.portailPatient.title')), 1),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_unref(Checkbox), {
              modelValue: doctorInformationPortailPatient.value.isTeleconsultationAvailable,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((doctorInformationPortailPatient.value.isTeleconsultationAvailable) = $event)),
              binary: "",
              onValueChange: updatePwrInformationPortailPatient
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(t)('settings.params.account.portailPatient.teleconsultation')), 1),
            _createVNode(_unref(Checkbox), {
              modelValue: doctorInformationPortailPatient.value.openToNewPatients,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((doctorInformationPortailPatient.value.openToNewPatients) = $event)),
              binary: "",
              onValueChange: updatePwrInformationPortailPatient
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_34, _toDisplayString(_unref(t)('settings.params.account.portailPatient.openToNewPatient')), 1)
          ]),
          (slug.value != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("label", _hoisted_36, _toDisplayString(_unref(t)('settings.params.account.portailPatient.slug.title')), 1),
                _createVNode(esHealthProSlugSettings, {
                  "doctor-id": _unref(currentPersonWithRole).personWithRoleId,
                  "input-id": "slug",
                  slug: slug.value,
                  "institute-slugs": instituteSlugs.value,
                  onUpdateSlug: onDoctorSlugUpdate
                }, null, 8, ["doctor-id", "slug", "institute-slugs"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("label", _hoisted_37, _toDisplayString(_unref(t)('settings.params.account.portailPatient.generalMessage')), 1),
          _createElementVNode("div", _hoisted_38, [
            _createVNode(EsEditor, {
              class: "flex-1 pad-m",
              "ref-editor": "generalMessageEditor",
              modelValue: doctorInformationPortailPatient.value.generalMessage,
              editorStyle: { height: '200px'},
              "heading-option": [],
              onTextChange: _cache[29] || (_cache[29] = ($event: any) => (updateGeneralMessage($event)))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("label", _hoisted_39, _toDisplayString(_unref(t)('settings.params.account.portailPatient.schedule')), 1),
          _createElementVNode("div", _hoisted_40, [
            _createVNode(EsEditor, {
              class: "flex-1 pad-m",
              "ref-editor": "weekEditor",
              modelValue: doctorInformationPortailPatient.value.weekSchedule,
              "heading-option": [],
              "text-formatting-option": false,
              editorStyle: { height: '200px'},
              onTextChange: _cache[30] || (_cache[30] = ($event: any) => (updateWeekSchedule($event)))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("label", _hoisted_41, _toDisplayString(_unref(t)('settings.params.account.portailPatient.fees')), 1),
          _createElementVNode("div", _hoisted_42, [
            _createVNode(EsEditor, {
              class: "flex-1 pad-m",
              "ref-editor": "feeEditor",
              modelValue: doctorInformationPortailPatient.value.fees,
              "heading-option": [],
              "text-formatting-option": false,
              onTextChange: _cache[31] || (_cache[31] = ($event: any) => (updateFee($event)))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("label", _hoisted_43, _toDisplayString(_unref(t)('settings.params.account.portailPatient.meanOfPayement')), 1),
          _createElementVNode("div", _hoisted_44, [
            _createVNode(EsEditor, {
              class: "flex-1 pad-m",
              "ref-editor": "meanOfPayementEditor",
              modelValue: doctorInformationPortailPatient.value.meansOfPayment,
              "heading-option": [],
              "text-formatting-option": false,
              onTextChange: _cache[32] || (_cache[32] = ($event: any) => (updateMeanOfPayement($event)))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("label", _hoisted_45, _toDisplayString(_unref(t)('settings.params.account.portailPatient.presentation')), 1),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(EsEditor, {
              class: "flex-1 pad-m",
              "ref-editor": "presentationEditor",
              modelValue: doctorInformationPortailPatient.value.presentation,
              editorStyle: { height: '300px'},
              onTextChange: _cache[33] || (_cache[33] = ($event: any) => (updatePresentation($event)))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("label", _hoisted_47, _toDisplayString(_unref(t)('settings.params.account.portailPatient.diploma')), 1),
          _createElementVNode("div", _hoisted_48, [
            _createVNode(EsEditor, {
              class: "flex-1 pad-m",
              "ref-editor": "diplomaEditor",
              modelValue: doctorInformationPortailPatient.value.diploma,
              "heading-option": [],
              "text-formatting-option": false,
              onTextChange: _cache[34] || (_cache[34] = ($event: any) => (updateDiploma($event)))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("label", _hoisted_49, _toDisplayString(_unref(t)('settings.params.account.portailPatient.complementaryInformation')), 1),
          _createElementVNode("div", _hoisted_50, [
            _createVNode(EsEditor, {
              class: "flex-1 pad-m",
              modelValue: doctorInformationPortailPatient.value.complementaryInformation,
              editorStyle: { height: '300px'},
              onTextChange: _cache[35] || (_cache[35] = ($event: any) => (updateComplementaryInformation($event)))
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})